import { TENANT } from './tenantTypes'

export const TENANTS_TO_SHOW_RX_NOT_IN_CATALOG_PRODUCTS = [
  TENANT.CH,
  TENANT.COM,
]
